const SEARCH_FIELD_NAMES = {
  ROUTE: 'Route',
};

export default SEARCH_FIELD_NAMES;
